<template>
  <div :class="['pointsLabel', `-${points ? 'enabled' : 'disabled'}`, { '-onlyText': onlyText }]">
    <slot>{{ pointsText }}</slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

import i18n from '@web/plugins/i18n'
import { getNumberDecliner } from '@web/common/Utils'

export default defineComponent({
  name: 'PointsLabelV3',
  props: {
    points: {
      type: Number,
      default: 0
    },
    onlyText: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const pointsText = computed(() => {
      const text = getNumberDecliner({
        n: props.points,
        single: i18n.global.t('pointsDecliner.point'),
        multiple: i18n.global.t('pointsDecliner.points'),
        multiple2: i18n.global.t('pointsDecliner.points2')
      })

      return `${props.points} ${text}`
    })

    return {
      pointsText
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@web/assets/scss/textContents.scss';

.pointsLabel {
  padding: 4px 8px;
  @extend .text-xs;
  color: var(--ac-color-dark-gray);
  background-color: #EBECED;
  border-radius: 4px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  &.-disabled {
    color: var(--ac-color-dark-gray);
    background-color: #EBECED;
  }

  &.-started,
  &.-open,
  &.-enabled {
    color: var(--ac-color-blue);
    background-color: #F9EFFF;
  }

  &.-ended,
  &.-done {
    color: var(--ac-color-white);
    background-color: var(--ac-color-green);

    &:before {
      content: '';
      display: block;
      width: 16px;
      height: 16px;
      margin-right: 4px;
      background: url(~@ui-kit/icons/icon-done.svg);
    }
  }

  &.-menu {
    color: var(--ac-color-white);
    background-color: var(--ac-color-purple);
  }

  &.-onlyText {
    padding: 0;
    background-color: transparent;
    color: var(--ac-color-deep-liliac);
  }
}
</style>
